import { render } from 'preact';
import { TestComponent } from './components/TestComponent';

const container = document.getElementById('test-el');
if (container) {
   render(<TestComponent name="world" />, container);
}
